import React from 'react';
import LoadingImg from './../assets/images/loading.svg'
const Loading = () => {
    return(
        <div className="loading-holder">
            <img src={LoadingImg} alt="loading" width={40}/>
        </div>
    )
};

export default Loading;